import * as UserSearchHistoryConstants from "./UserSearchHistoryConstants";
import * as CommonConstants from "Common/constants/commonConstants";

// Object.assign is not yet fully supported in all browsers, so we fallback to
// a polyfill
const assign = Object.assign || require("object.assign");

const initialState = {
  fetchUserSearchHistorylistStatus:"", 
  fetchUserSearchHistoryErrMsg: "",
  userSearchHistorylist: [],
};

export default function userSearchHistoryReducer(state = initialState, action) {
  switch (action.type) {
    /*
     * updation of state according to the fetch watchlist actions dispatched
     */
    case UserSearchHistoryConstants.FETCH_USERS_SEARCH_HISTORY_REQUEST: {
      const newState = {
        ...state,
        fetchUserSearchHistorylistStatus: CommonConstants.STATUS_PENDING, // SUCCESS -> PENDING -> FAILED | SUCCESS
        fetchUserSearchHistoryErrMsg: "",
        userSearchHistorylist: [],
      };
      return assign({}, state, newState);
    }
    case UserSearchHistoryConstants.FETCH_USERS_SEARCH_HISTORY_SUCCESS: {

      
      const newState = {
        ...state,
        fetchUserSearchHistorylistStatus: CommonConstants.STATUS_SUCCESS, // SUCCESS -> PENDING -> FAILED | SUCCESS
        fetchUserSearchHistoryErrMsg: "",
        userSearchHistorylist: [...action.payload],
      };
      return assign({}, state, newState);
    }
    
    default:
      return state;
  }
}
